import { client } from 'helpers/client'

export  enum DiscriminatorVal {
Forever = 1,
Monthly = 2,
Yearly = 3 
}


class PaymentService {
    get_payMethods =  () => {
        return client('/Invoice/GetPaymentMethods',)
    }
    getCardsToken = (payMethodId:any)=>{
        return client('/Payments/ListCardTokens',{params:{payMethodId:payMethodId}})
    }
    createCardToken = (fawryData:any)=>{
        return client('/Payments/CreateCardToken',{data:fawryData})
    }
    addCardToken = (CardData:any)=>{
        return client('/Payments/CreateCardTokenCallBack',{data:CardData})
    }
    updateCardToken = (CardData:any)=>{
        return client('/Payments/UpdateCardToken',{data:CardData})
    }
    deleteCardToken = (paymentMethodId:any,cardToken:any)=>{
        return client('/Payments/DeleteCardToken',{params:{paymentMethodId:paymentMethodId,cardToken:cardToken},method:'POST'})
    }
    getApp_payDetails = (VersionId:any,PriceLevelId:any,Discriminator:any,addOnId:any,versionReleaseId:any,VersionSubscriptionId:any,paymentCountryId:any) => {
        return client('/Invoice/GetApplicationPaymentDetails',{params:{VersionId:VersionId,PriceLevelId:PriceLevelId,Discriminator:Discriminator,AddOnId:addOnId,versionReleaseId:versionReleaseId,VersionSubscriptionId:VersionSubscriptionId,PaymentCountryId:paymentCountryId},method:'POST'})
    }
    getInvoice_payDetails = (InvoiceId:any) => {
        return client('/Invoice/GetInvoicePaymentDetails',{params:{InvoiceId:InvoiceId},method:'POST'})
    }
    createUnPaidInvoice = (unPaidInvoice:any)=> {
        return client('/Invoice/CreateUnPaidInvoice',{data:unPaidInvoice})
    }
    payByFawryCard = (fawryData:any)=>{
        return client('/Invoice/PayAndSubscribe',{data:fawryData})
    }
    payByBank = (bankData:any)=>{
        return client('/InvoiceController/Bank/ConfirmOrderCallBack',{data:bankData})
    }
    send_payDatails =  (payDetails:any) => {
        return client('/Invoice/PayAndSubscribe',{data:payDetails})
    }
    do_Pay_fawry =(param:any) => {
        return client('/Invoice/Fawry/CallBackThreeDSecureUrl',{params:param})
    } 
    do_pay =  (token:any,payerId:any) => {
        return client('/Invoice/CapturePayPalOrder',{params:{token:token,payerId:payerId}})
    }
    
   
}

const _paymentService = new PaymentService()

export default _paymentService

